import { useSelector } from 'react-redux';
import { selectFeatureFlags } from '../CommonSelectors/CommonAreaSelector';
import { FeatureFlag, Feature } from '../CommonSelectors/CommonArea.types';

export const isFeatureEnabled = (feature: Feature, featureFlags: FeatureFlag[]) => {
  const foundFeatureFlag = featureFlags.find(({ name }) => name === feature);

  return foundFeatureFlag ? foundFeatureFlag.enabled : false;
};

export const useFeatureFlag = (feature: Feature) => {
  const featureFlags = useSelector<any, FeatureFlag[]>(selectFeatureFlags);

  return isFeatureEnabled(feature, featureFlags);
};
